import { makeStyles } from "@material-ui/styles";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from "@material-ui/core";
import React, { useState } from "react";
import moment from "moment/moment";
import { ESTADOS_COTIZACIONES } from "../../../utils/constants";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { PracticaItem } from "../../autorizaciones/gestionAuditoria/PracticaItem";
import Collapse from "@material-ui/core/Collapse";
import IconEstado from "../../autorizaciones/UI/IconEstado";
import { ModalCotizaciones } from "./ModalCotizaciones";
import { NotasMenu } from "../../autorizaciones/gestionAuditoria/Menus/NotasMenu";
import { Notes } from "@material-ui/icons";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const SolicitudesItem = (props) => {
  const { item, estadosSolicitud } = props;
  const [open, setOpen] = useState(false);
  const [openModalCotizaciones, setOpenModalCotizaciones] = useState(false);
  const classes = useRowStyles();
  const [showModalNotas, setShowModalNotas] = useState(false);
  const [idSolicitudNota, setIdSolicitudNota] = useState(null);
console.log(item)
  return (
    <>
      {
        openModalCotizaciones && (
          <ModalCotizaciones
            open={openModalCotizaciones}
            closeModalHandler={() => {
              setOpenModalCotizaciones(false);
            }}
            materiales = {item.practicas
            ?.map(a => a.materiales)
            .filter(m => m && m.length > 0)}      
            idSolicitud={item.idSolicitud}
            item={item}
            estadosSolicitud={estadosSolicitud}
          />
        )
      }
      {showModalNotas && (
        <Dialog
          open={showModalNotas}
          onClose={() => setShowModalNotas(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle>Notas de Orden N°{idSolicitudNota}</DialogTitle>
          <DialogContent>
            <NotasMenu showBotonAgregar={false} desdeIngresoSolicitud={false} idSolicitudNota={idSolicitudNota} />
          </DialogContent>
        </Dialog>
      )}
      <TableRow className={classes.root}>
        <TableCell></TableCell>
        <TableCell align="right">
          {item.urgente && (
            <IconEstado
              texto={"U"}
              useColorTable={true}
              descripcion={'Urgente'}
              extraMarginRight={true}
              backgroundColor={"red"}
            />
          )}
          <IconEstado
            useColorTable={true}
            texto={item?.estadosSolicitud?.letra}
            backgroundColor={item?.estadosSolicitud?.color}
            descripcion={item?.estadosSolicitud?.descripcion}
          />
        </TableCell>
        <TableCell>{moment(item.fechaEnviada).format("DD/MM/YYYY")}</TableCell>
        <TableCell>{item.idSolicitud}</TableCell>
        <TableCell>{item.idPresupuesto}</TableCell>
        <TableCell>{item.tipoSolicitud.descripcionTipo}</TableCell>
        <TableCell>{item.conInternacion === true ? 'SI' : 'NO'}</TableCell>
        <TableCell>{item.practicas.recuperoSur === true ? 'SI' : 'NO'}</TableCell>
        <TableCell>{item.afiliado.apellido_y_nombre}</TableCell>
        <TableCell>{item.afiliado.carnet}</TableCell>
        <TableCell></TableCell>
        <TableCell>{item.practicas?.map(s => s.prescriptor?.nombre)}</TableCell>
        <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          <Tooltip title="Notas">
            <Notes
              onClick={() => {
                setIdSolicitudNota(item.idSolicitud);
                setShowModalNotas(true);
              }}
            />
          </Tooltip>
        </TableCell>
        <TableCell>{Number(estadosSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_COTIZACION && (
          <Button color="primary" variant="contained"
            onClick={() => setOpenModalCotizaciones(true)}>
            COTIZAR
          </Button>)
        }</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
          colSpan={11}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Practicas
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Práctica</TableCell>
                    <TableCell>Práctica</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell>Materiales</TableCell>
                    <TableCell>Institucion</TableCell>
                    {(item.conInternacion || item.idPrestacion) &&
                      <TableCell>Profesional</TableCell>
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.practicas.map((practica) => (
                    <PracticaItem
                      key={practica?.idCodNom?.toString()}
                      conInternacion={practica.conInternacion}
                      idPrestacion={item.idPrestacion}
                      idTipoSolicitud={item?.idTipoSolicitud}
                      item={practica}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
};